var swiper = new Swiper('.swiper-container', {
  loop: window.slides > 1,
  allowTouchMove: true,


  pagination: {
      el: '.swiper-pagination',
      clickable: true,
  },
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
});

var swiper = new Swiper('.swiper-container-hero', {
  loop: window.slides > 1,
  pagination: {
      el: '.swiper-pagination',
      clickable: true,
  },
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
});

var swiper = new Swiper('.swiper-beer-images', {
  loop: window.slides > 1,
  pagination: {
      el: '.swiper-pagination',
      clickable: true,
  },
  navigation: {
    nextEl: ".swiper-button-next",
  },
});

var swiper = new Swiper('.carousel-wrapper', {
  loop: window.slides > 1,
  pagination: {
      el: '.swiper-pagination',
      clickable: true,
  },
  navigation: {
    nextEl: ".swiper-button-next",
  },
});


function printSection(id) {
  var prtContent = document.getElementById(id);
  var WinPrint = window.open('', '', 'left=0,top=0,width=800,height=900,toolbar=0,scrollbars=0,status=0');
  WinPrint.document.write('<link href="/css/app.css" rel="stylesheet"><div class="print-wrapper">' + prtContent.innerHTML + '</div>');
  WinPrint.document.close();
  WinPrint.focus();
  WinPrint.print();
}


function setAgeConsent(duration) {
  Cookies.set('age-consent', 1, { expires: parseInt(duration) });
  location.reload();
}

function refuseConsent() {
  location.reload();
}


function forceDownload(blob, filename) {
  var spinner = document.getElementById('spinner');

    var a = document.createElement('a');
  a.download = filename;
  a.href = blob;
  document.body.appendChild(a);
  a.click();
  a.remove();
  spinner.classList.add("hidden");
}

function downloadResource(e, url, filename) {
  e.preventDefault();
  var spinner = document.getElementById('spinner');
  spinner.classList.remove("hidden");
  if (!filename) filename = url.split('\\').pop().split('/').pop();
  fetch(url, {
      headers: new Headers({
        'Origin': location.origin
      }),
      mode: 'cors'
    })
    .then(response => response.blob())
    .then(blob => {
      let blobUrl = window.URL.createObjectURL(blob);
      forceDownload(blobUrl, filename);
    })
    .catch(e => console.error(e));
}